export const SET_MAIL_LOADER = (state, payload) => {
  state.sendmail_loading = payload;
};
export const SET_SUBCRIBE_LOADER = (state, payload) => {
  state.subscribe_mail_loading = payload;
};
export const SET_GETSTATED_LOADER = (state, payload) => {
  state.get_started_loading = payload;
};
